import React from "react";
import { Box, makeStyles, Tooltip } from "@material-ui/core";

const MenuIndicator = ({ indicators, menuIndicators }) => {
  const classes = useStyles();
  if (!indicators || indicators.length === 0) {
    return null;
  }

  return (
    <Box display="flex" className={classes?.indicators ?? ""}>
      {indicators.map((indicator, index) => {
        let indicatorValue = menuIndicators?.leave?.[indicator.key] ?? 0;
        if (indicatorValue > 0) {
          return (
            <Tooltip key={index} title={indicator.label}>
              <Box
                className={classes?.indicator ?? ""}
                style={{
                  backgroundColor: indicator.bgColor,
                  border: `1px solid ${indicator.textColor}`,
                }}
              >
                <span
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Mulish",
                    color: indicator.textColor,
                  }}
                >
                  {indicatorValue}
                </span>
              </Box>
            </Tooltip>
          );
        }
        return null;
      })}
    </Box>
  );
};

export default React.memo(MenuIndicator);

const useStyles = makeStyles((theme) => ({
  indicator: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
    borderRadius: "10px",
    width: "22px",
    height: "22px",
  },
  indicators: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
}));
